import React, { useEffect } from "react"

import { graphql } from "gatsby"
import { ArticleImageFieldsFragment } from "../../../../../../graphql-types"

import * as styles from "./image.module.scss"
import { elementOffset, transformItem } from "../../../functions/functions"
import StructuredTextContent from "../structured-text-content/structured-text-content"

type ArticleImageProps = {
  data: ArticleImageFieldsFragment
}

const ArticleImage: React.FC<ArticleImageProps> = ({ data }) => {
  const handleScrollAnimation = () => {
    document.addEventListener("scroll", () => {
      const container = document.getElementsByClassName(styles.container)

      Array.from(container).forEach(artContainer => {
        if (window.scrollY >= elementOffset(artContainer).top - 700) {
          transformItem(artContainer.getElementsByClassName(styles.image)[0], 400)
          transformItem(artContainer.getElementsByClassName(styles.caption)[0], 800)
          transformItem(artContainer.getElementsByClassName(styles.optionalText)[0], data.caption ? 1200 : 800)
        }
      })
    })
  }

  useEffect(() => {
    handleScrollAnimation()
  }, [])

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <img src={data.image.url} alt={data.image.alt || ""} className={styles.image} title={data.image.title} />
        {data.caption && <p className={styles.caption}>{data.captionText}</p>}
        {data.optionalTextOnLeftSide && (
          <div className={styles.optionalText}>
            <StructuredTextContent data={data.optionalTextOnLeftSide.value} isNotRichContent={true} />
          </div>
        )}
      </div>
    </div>
  )
}

export const fragment = graphql`
  fragment ArticleImageFields on DatoCmsArticleImage {
    __typename
    id
    image {
      alt
      format
      title
      url
    }
    caption
    captionText
    optionalTextOnLeftSide {
      value
    }
  }
`

export default ArticleImage
